import { Component, OnDestroy, OnInit } from '@angular/core';
import { ServicoDefaultPage } from '../../../components/servico-default-page';
import { ServicoService } from 'src/app/services/servico.service';
import { Router } from '@angular/router';
import { ArquivosManager } from 'src/app/components/arquivos-manager';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { renameDefaultFilenames } from 'src/app/util/rename-default-filenames';
import { ServicoCredenciamentoCaminhoesFossa } from 'src/app/models/credenciamento-caminhoes-fossa.model';
import { IdentificacaoAtendimento } from 'src/app/models/Servico.model';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-credenciamento-caminhao-limpa-fossa',
  templateUrl: './credenciamento-caminhao-limpa-fossa.component.html',
  styleUrls: ['./credenciamento-caminhao-limpa-fossa.component.css'],
})
export class CredenciamentoCaminhaoLimpaFossaComponent
  extends ServicoDefaultPage
  implements OnInit, OnDestroy
{
  arquivosManager = new ArquivosManager();

  formSolicitante!: FormGroup;
  formServico!: FormGroup;

  constructor(
    private messageService: MessageService,
    private fb: FormBuilder,
    servicoService: ServicoService,
    router: Router
  ) {
    super(servicoService, router);
  }

  ngOnInit(): void {
    this.getServico('credenciamento-caminhoes-limpa-fossa', () => {
      this._inicializarFormSolicitante();
      this._inicializarForm();
    });
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  putDadosSolicitante() {
    this.ACTIVE_INDEX = 1;
    this.formSolicitante.disable();
  }

  concluirCadastro() {
    this.loading = true;

    let formulario: ServicoCredenciamentoCaminhoesFossa = {
      ...this.formSolicitante.value,
      informacoes: this.formServico.value['informacoes'],
      servicoValores: this.servico?.servicoFormulario.map((campo) =>
        Number(this.formServico.value[campo.id].id)
      ),
    };

    const formData = new FormData();
    var arquivos = renameDefaultFilenames(this.arquivosManager.anexos);
    arquivos.forEach((anexo) => {
      formData.append('arquivos', anexo, anexo.name);
    });

    formData.append(
      'formAtendimento',
      new Blob([JSON.stringify(formulario)], { type: 'application/json' })
    );

    this.servicoService
      .postServicoCredenciamentoCaminhoesLimpaFossa(formData)
      .subscribe({
        next: ({ id, ano, hash }) => {
          this.loading = false;
          this.dadosSolicitacao = new IdentificacaoAtendimento(id, ano, hash);
          this.ACTIVE_INDEX = 2;
        },
        error: (error) => {
          this.loading = false;

          this.messageService.add({
            severity: 'error',
            detail: error.error.message,
          });
        },
      });
  }

  _inicializarFormSolicitante() {
    this.formSolicitante = this.fb.group({
      cnpj: ['', [Validators.required, Validators.pattern(/^(\D*\d){14}\D*$/)]],
      nome: ['', [Validators.required]],
      endereco: ['', [Validators.required]],
      telefone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      responsavel: ['', [Validators.required]],
      declaracaoVeracidade: [null, Validators.required],
      declaracaoAceite: [null, Validators.required],
    });
  }

  _inicializarForm() {
    const grupo: any = {
      informacoes: ['', Validators.required],
    };

    this.servico?.servicoFormulario.forEach((campo) => {
      grupo[campo.id] = ['', Validators.required];
    });

    this.formServico = this.fb.group(grupo);

    this.servico?.servicoAnexos.forEach((anexo) =>
      this.arquivosManager.inicializarCategoriaArquivo(anexo.nomeAnexo)
    );

    this.arquivosManager.inicializarCategoriaArquivo(
      this.arquivosManager.ANEXO_DOCUMENTO_OUTROS
    );
  }

  isArquivosObrigatoriosSelecionados() {
    return this.servico?.servicoAnexos
      .filter((s) => s.envioObrigatorio)
      .every((s) => this.arquivosManager.isCategoriaFilled(s.nomeAnexo));
  }
}
